import request from "@/utils/request";
import base from './base';

// 删除原有的 host 定义
export const host = base.api_data;

const api_inorder = '/delivery/api_inorder_list/'; // 获取乐檬调入单
const get_inorder_list = '/delivery/get_inorder_statistics/'; // 获取调入单统计
const calculate_delivery_cost = '/delivery/calculate_delivery_cost/'; // 计算配送费
const get_delivery_cost_list = '/delivery/get_delivery_cost_list/'; // 获取配送费列表

export default {
  //配送订单
  api_inorder(params) {
    return request.get(`${host}${api_inorder}`, { params });
  },
  get_inorder_list(params) {
    return request.get(`${host}${get_inorder_list}`, { params });
  },
  // 计算并保存配送费分摊
  calculateDeliveryCost(data) {
    return request.post(`${host}${calculate_delivery_cost}`, data);
  },
  // 获取配送费分摊列表
  getDeliveryCostList(params) {
    return request.get(`${host}${get_delivery_cost_list}`, { params });
  }
};




